import { legacySatchelDiagnosticsMiddleware } from 'mini-diagnostics-common/lib/workflow/actions/satchelDiagnosticsMiddleware';
import { satchelLegacyWorkflowTrackerMiddleware } from 'mini-mail-workflow-tracking/lib/middlewares/satchelLegacyWorkflowTrackerMiddleware';

/**
 * Returns legacy satchel middlewares for mail module.
 */
export const getSatchelLegacyMiddlewaresForMail = () => {
    const middlewares = [];

    // The following is the middleware to track user workflows.
    middlewares.push(satchelLegacyWorkflowTrackerMiddleware);

    // track diagnostics
    middlewares.push(legacySatchelDiagnosticsMiddleware);

    return middlewares;
};
